import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BookingQualityControlDataComponent } from './booking-quality-control-data.component';
import { BookingQualityControlTitleComponent } from './booking-quality-control-title.component';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import {
    BookingOperationResultIconModule
} from "libraries/component/booking-information/components/booking-operation-result-icon/booking-operation-result-icon.module";
import { PipesModule } from "libraries/pipes/pipes.module";
import { TdTextModule } from "libraries/component/table/td-text/td-text.module";
import { ThTextModule } from "libraries/component/table/th-text/th-text.module";
import { TravellerDataTranslationModule } from "libraries/service/traveller-data-translation/traveller-data-translation.module";
import { IsInArrayModule } from "libraries/pipes/is-in-array/is-in-array.module";
import { PermissionModule } from "libraries/permission/permission.module";
import {LoaderModule} from "../loader/loader.module";


@NgModule({
    declarations: [
        BookingQualityControlDataComponent,
        BookingQualityControlTitleComponent
    ],
    imports: [
        CommonModule,
        FontAwesomeModule,
        BookingOperationResultIconModule,
        PipesModule,
        TdTextModule,
        ThTextModule,
        TravellerDataTranslationModule,
        IsInArrayModule,
        PermissionModule,
        LoaderModule
    ],
    exports: [
        BookingQualityControlDataComponent,
        BookingQualityControlTitleComponent
    ],
    providers: [],
})
export class BookingQualityControlDataModule {
}
